import { Pipe, PipeTransform } from '@angular/core';
import { IDataUrlParam } from 'src/app/shared/framework/images/models/DataUrlParam';

@Pipe({
  name: 'dataUrl',
})
export class DataUrlPipe implements PipeTransform {
  public transform(photo: IDataUrlParam): string {
    if (!photo) {
      return '';
    }
    const contentTypeString = photo.contentType.replace('image/', '');
    return `data:image/${contentTypeString};base64,${photo.fileData}`;
  }
}
